import { render, staticRenderFns } from "./AmazonSellerFields.vue?vue&type=template&id=61249971&scoped=true"
import script from "./AmazonSellerFields.vue?vue&type=script&lang=js"
export * from "./AmazonSellerFields.vue?vue&type=script&lang=js"
import style0 from "./AmazonSellerFields.vue?vue&type=style&index=0&id=61249971&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61249971",
  null
  
)

export default component.exports